import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'Actions';
import MediaBreakpoints from 'Utils/MediaBreakpoints';
import StandardTextField from 'Utils/redux_form_inputs/StandardTextField';
import StandardSelectField from 'Utils/redux_form_inputs/StandardSelectField';
import { ArrowDown } from 'Utils/SvgIcons';
import { combineDateAndTime, debounce } from 'HelperFunctions/general';
import {
  setFilterParams,
  filterFromPropsAndState,
  filterObjToArray,
} from 'HelperFunctions/urls';
import CategoryFilterDesktop from './CategoryFilterDesktop';
import CategoryFilterMobile from './CategoryFilterMobile';
import AvailableItemList from './AvailableItemList';
import BusinessNoItemsPage from './BusinessNoItemsPage';
import Suggestions from 'Utils/Suggestions';
import axios from 'axios';
import LoadingSpinner from 'Utils/LoadingSpinner';
import classnames from 'classnames';
import PageMetaData from 'Utils/PageMetaData';
import isEqual from 'lodash/isEqual';
import withTags from '../hoc/withTags';

import EventHeader from './EventHeader';

class SearchItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      results: [],
      filter: props.filter,
      tags: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.performSearch = debounce(this.performSearch, 500);

    this.handleQueryChange = debounce(this.handleQueryChange, 1000);
    this.handleQuantityChange = debounce(this.handleQuantityChange, 1000);
  }

  componentDidMount() {
    const { filter, reloadInventory, fetchSfCategories, fetchInventoryColors } =
      this.props;

    reloadInventory(filter);
    fetchSfCategories(filter.query);
    fetchInventoryColors(filter.query);
  }

  componentWillReceiveProps(nextProps) {
    const oldFilter = this.props.filter;
    let newFilter = nextProps.filter;

    if (!isEqual(newFilter, oldFilter)) {
      const { reloadInventory, fetchSfCategories, fetchInventoryColors } =
        this.props;
      const filterToSubmit = Object.assign(newFilter);
      reloadInventory(filterToSubmit);
      fetchSfCategories(filterToSubmit.query);
      fetchInventoryColors(filterToSubmit.query);
    }
  }

  handleNestedSfCategorySelected = (isChecked, nestedSfCategory) => {
    const {
      filter: { selectedNestedSfCategories },
    } = this.props;

    let newSelected = [...selectedNestedSfCategories];

    if (isChecked) {
      const selectedCatIndex = newSelected.indexOf(String(nestedSfCategory.id));
      if (selectedCatIndex === -1) {
        newSelected.push(String(nestedSfCategory.id));
      }
    } else {
      newSelected = newSelected.filter(
        (ns) => String(ns) !== String(nestedSfCategory.id)
      );
    }

    const { location, history } = this.props;

    setFilterParams(
      {
        selectedNestedSfCategories: [...new Set(newSelected)].join(','),
        page: null,
      },
      location,
      history
    );
  };

  handleColorSelection = (isChecked, id) => {
    const {
      filter: { selectedColors },
    } = this.props;
    const index = selectedColors.indexOf(id.toString());
    let newSelection = selectedColors.slice();
    if (isChecked) {
      if (index === -1) {
        newSelection.push(id);
      }
    } else {
      if (index > -1) {
        newSelection.splice(index, 1);
      }
    }
    const { location, history } = this.props;
    setFilterParams(
      {
        selectedColors: newSelection.join(','),
        page: null,
      },
      location,
      history
    );
  };

  clearColorSelection = () => {
    const { location, history } = this.props;
    setFilterParams(
      {
        selectedColors: null,
        page: null,
      },
      location,
      history
    );
  };

  handleQuantitySelection = (newValues) => {
    const [minQuantity, maxQuantity] = newValues;
    this.setState({
      filter: {
        ...this.state.filter,
        minQuantity,
        maxQuantity,
      },
    });
    this.handleQuantityChange(newValues);
  };

  handleQuantityChange(newValues) {
    const [minQuantity, maxQuantity] = newValues;
    const { location, history } = this.props;
    setFilterParams(
      {
        minQuantity,
        maxQuantity,
        page: null,
      },
      location,
      history
    );
  }

  handleSearch(event) {
    const { value } = event.target;
    this.setState({
      filter: {
        ...this.state.filter,
        query: value,
      },
    });
    this.performSearch(value);
  }

  handleQueryChange(value) {
    const { location, history } = this.props;
    setFilterParams(
      {
        query: value,
        page: null,
      },
      location,
      history
    );
  }

  performSearch = async (value) => {
    const { clientLocation, searchTags } = this.props;

    // this.getResults(value);

    if (value && clientLocation && searchTags) {
      try {
        const tags = await searchTags(value, clientLocation.id);
        this.setState({ tags: tags || [] });
      } catch (error) {
        console.error('Error fetching tags:', error);
        this.setState({ tags: [] });
      }
    } else {
      this.setState({ tags: [] });
    }
  };

  getResults = (query) => {
    const { clientLocation } = this.props;
    axios
      .get(
        process.env.REACT_APP_API_DOMAIN +
          `/api/portal/inventories/search_filter?query=${query}&location_id=${clientLocation.id}`
      )
      .then(({ data }) => {
        this.setState({
          results: data.products,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleClick = (productType, id) => {
    this.props.history.push(`/shop/${productType}/${id}`);
  };

  handleCategoryClick = (id) => {
    const selected = id;
    this.props.history.push(`/shop?query=&selectedCategories=${selected}`);
    this.setState({
      filter: {
        query: '',
      },
      results: [],
    });
  };

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      const { query } = this.state.filter;
      this.handleQueryChange(query);
    }
  };

  handleNumberPerChange = (event) => {
    const { location, history } = this.props;
    setFilterParams(
      {
        numberPer: event.target.value,
      },
      location,
      history
    );
  };

  notFocused = () => {
    this.setState({
      results: [],
      tags: [],
      filter: {
        query: '',
      },
    });
  };

  render() {
    const {
      filter: { selectedNestedSfCategories, selectedColors, numberPer },
      loading,
      loaded,
      inventory,
      storefrontShopSetting,
      event,
    } = this.props;

    const { filter, results, tags } = this.state;
    const allowedFilterList = (storefrontShopSetting.allowedFilters || '')
      .split(',')
      .filter(Boolean);
    const noFilter =
      allowedFilterList.length &&
      !allowedFilterList.some((r) =>
        ['date', 'quantity', 'color', 'category'].includes(r)
      );
    const noItems = inventory.length === 0;

    return (
      <div
        className={classnames({
          shop: true,
          noItemsDeprecated: noItems,
        })}
      >
        <PageMetaData setting={storefrontShopSetting} />
        <header>
          <div className='searchFilter'>
            <StandardTextField
              type='search'
              placeholder='Search for Items to Rent...'
              meta={{ error: {} }}
              input={{
                value: filter.query,
                onChange: this.handleSearch,
                onKeyPress: this.handleKeyPress,
                onBlur: () => setTimeout(this.notFocused, 500),
              }}
            />
            {filter.query !== '' && (
              <Suggestions
                results={results}
                tags={tags.map((t) => t.name)}
                handleClick={this.handleClick}
                handleCategoryClick={this.handleCategoryClick}
              />
            )}
          </div>
          {event && event.editingEvent && <EventHeader />}
        </header>
        {!loaded ? (
          <LoadingSpinner />
        ) : (
          <section
            className={classnames({
              storefront: true,
              noFilter: noFilter,
            })}
          >
            <div className='numberSelectWrapper'>
              <StandardSelectField
                className='numberSelect'
                meta={{}}
                input={{
                  name: 'numberPer',
                  value: numberPer,
                  onChange: this.handleNumberPerChange,
                }}
              >
                <option value='12'>12</option>
                <option value='24'>24</option>
                <option value='48'>48</option>
              </StandardSelectField>
              <ArrowDown className='numberSelectArrow' />
            </div>
            <MediaBreakpoints
              desktop={
                <CategoryFilterDesktop
                  history={this.props.history}
                  location={this.props.location}
                  showFilters={false}
                  handleSfCategorySelected={this.handleNestedSfCategorySelected}
                  onColorSelection={this.handleColorSelection}
                  onQuantitySelection={this.handleQuantitySelection}
                  selectedSfCategories={selectedNestedSfCategories}
                  selectedColors={selectedColors}
                  selectedMinQuantity={filter.minQuantity || 0}
                  selectedMaxQuantity={filter.maxQuantity || 500}
                  clearColorSelection={this.clearColorSelection}
                  editingEvent={event && event.editingEvent}
                />
              }
              mobile={
                <CategoryFilterMobile
                  showFilters={false}
                  handleSfCategorySelected={this.handleNestedSfCategorySelected}
                  onColorSelection={this.handleColorSelection}
                  onQuantitySelection={this.handleQuantitySelection}
                  selectedSfCategories={selectedNestedSfCategories}
                  selectedColors={selectedColors}
                  selectedMinQuantity={filter.minQuantity || 0}
                  selectedMaxQuantity={filter.maxQuantity || 500}
                  clearColorSelection={this.clearColorSelection}
                  forConnect
                />
              }
            />
            {loading ? (
              <LoadingSpinner />
            ) : noItems ? (
              <BusinessNoItemsPage />
            ) : (
              <AvailableItemList />
            )}
          </section>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parsedStorefrontSettings } = state.locations;
  const newFilter = filterFromPropsAndState(ownProps);

  const selectedColors = filterObjToArray(newFilter.selectedColors);
  const selectedNestedSfCategories = filterObjToArray(
    newFilter.selectedNestedSfCategories
  );
  const {
    event,
    event: { eventStart, eventStartTime, eventEnd, eventEndTime },
  } = state.cart;
  const eventStartDateTime = combineDateAndTime(eventStart, eventStartTime);
  const eventEndDateTime = combineDateAndTime(eventEnd, eventEndTime);
  const { inventory, loading, loaded } = state.products;
  const storefrontShopSetting = parsedStorefrontSettings.storefrontShopSetting;
  return {
    filter: {
      ...newFilter,
      selectedColors,
      selectedNestedSfCategories,
      eventStart: eventStartDateTime,
      eventEnd: eventEndDateTime,
    },
    event,
    inventory,
    loading,
    loaded,
    clientLocation: state.locations.location,
    location: ownProps.location,
    storefrontShopSetting,
  };
};

export default connect(mapStateToProps, actions)(withTags(SearchItems));
